import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from '.';
import PaymentsAPIController from 'PaymentsAPIController';

export function usePaymentDataQuery(options = {}) {
  return useQuery(
    [QUERY_KEYS.paymentData],
    () => PaymentsAPIController.getPaymentsInformation(false),
    options
  );
}
